import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import GrnList from '../Pages/GrnList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
const AddGrn = lazy(() => import('../Pages/AddGrn'))
const GrnView = lazy(() => import('../Pages/GrnView'))
const EditGrn = lazy(() => import('../Pages/EditGrn'))

function GrnRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/grn'
        render={() => (
          <React.Fragment>
            <GrnList history={history} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/grn/add'
        render={() => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <AddGrn />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/grn/view/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <GrnView {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/grn/edit/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <EditGrn {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        path='/:lng/sales/grn/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(GrnRoute)
